declare namespace $ {

	export class $mol_icon_ungroup extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=ungroup.view.tree.d.ts.map